enum PermissionName {
  ACTIVITY_CREATE = "crmactivities:c", // creating activities
  ACTIVITY_DELETE = "crmactivities:d", // deleting activities
  ACTIVITY_READ = "crmactivities:r", // viewing activities
  ACTIVITY_TYPES_CREATE = "crmactivitytypes:c", // creating activity types
  ACTIVITY_TYPES_DELETE = "crmactivitytypes:d", // deleting activity types
  ACTIVITY_TYPES_READ = "crmactivitytypes:r", // viewing activity types
  ACTIVITY_TYPES_UPDATE = "crmactivitytypes:u", // updating activity types
  ACTIVITY_UPDATE = "crmactivities:u", // updating activities
  COACHING_NOTE_CATEGORIES_CREATE = "coachingnotecategories:c", // managing coaching note categories
  COMPANY_CREATE = "accounts:c", // creating companies
  COMPANY_DELETE = "accounts:d", // deleting companies
  COMPANY_READ = "accounts:r", // viewing companies
  COMPANY_UPDATE = "accounts:u", // updating companies
  DASHBOARD_CREATE = "dashboards:c", // creating dashboards
  DASHBOARD_DELETE = "dashboards:d", // deleting dashboards
  DASHBOARD_READ = "dashboards:r", // viewing dashboards
  DASHBOARD_UPDATE = "dashboards:u", // updating dashboards
  DEAL_CREATE = "deals:c", // creating deals
  DEAL_DELETE = "deals:d", // deleting deals
  DEAL_READ = "deals:r", // viewing deals
  DEAL_STAGES_CREATE = "dealstages:c", // creating funnel stages
  DEAL_STAGES_DELETE = "dealstages:d", // deleting funnel stages
  DEAL_STAGES_READ = "dealstages:r", // viewing funnel stages
  DEAL_STAGES_UPDATE = "dealstages:u", // updating funnel stages
  DEAL_UPDATE = "deals:u", // updating deals
  DEVICE_PERMISSIONS_READ = "devicepermissions:r", // viewing reps' reported device-permission status
  DUPLICATES_READ = "dupes:r", // viewing duplicate records
  DUPLICATES_RECALCULATE = "dupes:c", // recalculate duplicates
  DUPLICATES_UPDATE = "dupes:u", // update access of dismissing duplicate records
  EMAILS_CREATE = "emails:c", // creating emails
  EMAILS_DELETE = "emails:d", // deleting emails
  EMAILS_READ = "emails:r", // viewing emails
  EMAILS_UPDATE = "emails:u", // updating emails
  EXPORT_CREATE = "reports:c", // creating new exports
  EXPORT_DELETE = "reports:d", // deleting exports
  EXPORT_DOWNLOAD = "reports:ex", // downloading exports
  EXPORT_READ = "reports:r", // reading list of exports
  EXPORT_UPDATE = "reports:u", // updating exports
  FILES_CREATE = "files:c", // uploading files
  FILES_DELETE = "files:d", // deleting files
  FILES_READ = "files:r", // viewing files
  FILES_UPDATE = "files:u", // updating files
  FUNNELS_CREATE = "funnels:c", // creating funnels
  FUNNELS_DELETE = "funnels:d", // deleting funnels
  FUNNELS_READ = "funnels:r", // viewing funnels
  FUNNELS_UPDATE = "funnels:u", // updating funnels
  IMPORT_CREATE = "imports:c", // creating new imports
  IMPORT_DELETE = "imports:d", // deleting imports
  IMPORT_READ = "imports:r", // viewing imports
  PERSON_CREATE = "contacts:c", // creating persons
  PERSON_DELETE = "contacts:d", // deleting persons
  PERSON_READ = "contacts:r", // viewing persons
  PERSON_UPDATE = "contacts:u", // updating persons
  PIN_LEGENDS_CREATE = "pinlegends:c", // creating pin legends and boundary legends
  PIN_LEGENDS_DELETE = "pinlegends:d", // deleting pin legends and boundary legends
  PIN_LEGENDS_READ = "pinlegends:r", // viewing pin legends and boundary legends
  PIN_LEGENDS_UPDATE = "pinlegends:u", // updating pin legends and boundary legends
  RESTORE_ENTITIES = "entities:restore", // restoring deleted entities
  STORAGE_CONNECTIONS_CREATE = "storageconnections:c", // creating storage connections
  STORAGE_CONNECTIONS_DELETE = "storageconnections:d", // deleting storage connections
  STORAGE_CONNECTIONS_READ = "storageconnections:r", // viewing storage connections
  STORAGE_CONNECTIONS_UPDATE = "storageconnections:u", // updating storage connections
  ROUTES_CREATE = "routes:c", // creating routes
  ROUTES_DELETE = "routes:d", // deleting routes
  ROUTES_READ = "routes:r", // viewing routes
  ROUTES_UPDATE = "routes:u", // updating routes
  TAGS_CREATE = "tags:c", // creating tags
  TAGS_DELETE = "tags:d", // deleting tags
  TAGS_READ = "tags:r", // viewing tags
  TAGS_UPDATE = "tags:u", // updating tags
  TERRITORIESS_CREATE = "territories:c", // creating territories
  TERRITORIESS_DELETE = "territories:d", // deleting territories
  TERRITORIESS_READ = "territories:r", // viewing territories
  TERRITORIESS_UPDATE = "territories:u", // updating territories
  TRIPS_CREATE = "trips:c", // create trips
  TRIPS_DELETE = "trips:d", // delete trips
  TRIPS_READ = "trips:r", // read trips
  TRIPS_UPDATE = "trips:u", // update trips
  UNSUBSCRIBED_EMAILS_CREATE = "unsubscribedemails:c", // creating bulk email unsubscriptions
  UNSUBSCRIBED_EMAILS_DELETE = "unsubscribedemails:d", // subscribing records back to bulk email
  UNSUBSCRIBED_EMAILS_READ = "unsubscribedemails:r", // viewing bulk email subscription status
  UNSUBSCRIBED_EMAILS_UPDATE = "unsubscribedemails:u", // unsubscribing records from bulk email
}

export default PermissionName;
